import React, {useCallback} from 'react';
import {useShoppingCartStore} from "../../model/store";
import ItemCart from "../itemCard/ItemCart";
import SlidingModal from "../../../../shared/ui/modal/SlidingModal";
import {
    ShoppingCartContent,
    StyledListCartItems,
    StyledSection,
    StyledShoppingCartContainer,
    StyledShoppingGoToBack
} from "./style";
import {StyledTitleSection} from "../../../../shared/ui/typography/style";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";


interface IProps {
    recommendationsSlot?: React.ReactNode;
}

const ShoppingCartModal: React.FC<IProps> = ({recommendationsSlot}) => {
    const {cartItems, isViewShoppingCart} = useShoppingCartStore();
    const setViewShoppingCart = useShoppingCartStore(state => state.setViewShoppingCart);

    const onClose = useCallback(() => {
        setViewShoppingCart(false);
    }, [setViewShoppingCart]);
    const  headerH = document.querySelector('header')?.clientHeight ?? 118;

    return (
        <SlidingModal key={''} top={headerH} isOpen={isViewShoppingCart} onClose={onClose}>
            <StyledShoppingCartContainer className={GLOBAL_STYLE_CONFIG.splitByPrefix('shopping-cart-container')}>
                <StyledShoppingGoToBack className={GLOBAL_STYLE_CONFIG.splitByPrefix('shopping-cart-go-back')}>
                    <button onClick={onClose}>
                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.66602 8.00004H20.3327" stroke="black" stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>
                            <path d="M8.33268 1.33337L1.66602 8.00004" stroke="black" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.33268 14.6667L1.66602 8" stroke="black" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Вернуться назад
                    </button>
                </StyledShoppingGoToBack>

                <ShoppingCartContent className={GLOBAL_STYLE_CONFIG.splitByPrefix('shopping-cart-content')}>
                    <StyledTitleSection className={GLOBAL_STYLE_CONFIG.splitByPrefix('section-title')}><span>Ваш кошик</span> для покупок</StyledTitleSection>
                    <StyledListCartItems className={GLOBAL_STYLE_CONFIG.splitByPrefix('shopping-cart-list')}>
                        {Array.isArray(cartItems) && cartItems.map((item, index) => (<ItemCart itemCart={item}/>))}
                    </StyledListCartItems>
                    {recommendationsSlot && <StyledSection>{recommendationsSlot}</StyledSection>}

                </ShoppingCartContent>
            </StyledShoppingCartContainer>

        </SlidingModal>
    );
};

export default ShoppingCartModal;